import { typedMemo } from '../../utils/components/typedMemo';
/**
 * stand-alone passthrough to avoid rerendering
 * children if parent state changes that doesn't
 * affect the child props
 */
export var FilterProps = typedMemo(function FilterProps(props) {
    return props.children(props);
});
//# sourceMappingURL=FilterProps.js.map